module.exports = function(ctx) {
var __t, __p = '';
__p += '<!-- Deliberately left empty.  Fill out this template if we ever need to show nav items in readonly mode -->';
return __p
}